var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFlowChart(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{opacity:0.5;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Flow chart") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Flow_chart",
    "data-name": "Flow chart"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 13,
    y: 5,
    width: 22,
    height: 5,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 20.05,
    y: 19.05,
    width: 7.91,
    height: 7.91,
    transform: "translate(-9.23 23.71) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 13,
    y: 54,
    width: 22,
    height: 5,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 20.05,
    y: 38.05,
    width: 7.91,
    height: 7.91,
    transform: "translate(-22.67 29.27) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 40,
    y: 37,
    width: 11,
    height: 10,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 40,
    y: 18,
    width: 11,
    height: 10,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34,61H14a3,3,0,0,1-3-3V55a3,3,0,0,1,3-3H34a3,3,0,0,1,3,3v3A3,3,0,0,1,34,61ZM14,54a1,1,0,0,0-1,1v3a1,1,0,0,0,1,1H34a1,1,0,0,0,1-1V55a1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34,12H14a3,3,0,0,1-3-3V6a3,3,0,0,1,3-3H34a3,3,0,0,1,3,3V9A3,3,0,0,1,34,12ZM14,5a1,1,0,0,0-1,1V9a1,1,0,0,0,1,1H34a1,1,0,0,0,1-1V6a1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24,36a1,1,0,0,1-1-1V30a1,1,0,0,1,2,0v5A1,1,0,0,1,24,36Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24,54a1,1,0,0,1-1-1V49a1,1,0,0,1,2,0v4A1,1,0,0,1,24,54Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24,17a1,1,0,0,1-1-1V12a1,1,0,0,1,2,0v4A1,1,0,0,1,24,17Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M24,31a1,1,0,0,1-.71-.29l-7-7a1,1,0,0,1,0-1.42l7-7a1,1,0,0,1,1.42,0l7,7a1,1,0,0,1,0,1.42l-7,7A1,1,0,0,1,24,31Zm-5.59-8L24,28.59,29.59,23,24,17.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24,50a1,1,0,0,1-.71-.29l-7-7a1,1,0,0,1,0-1.42l7-7a1,1,0,0,1,1.42,0l7,7a1,1,0,0,1,0,1.42l-7,7A1,1,0,0,1,24,50Zm-5.59-8L24,47.59,29.59,42,24,36.41Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38,24H31a1,1,0,0,1,0-2h7a1,1,0,0,1,0,2Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38,43H31a1,1,0,0,1,0-2h7a1,1,0,0,1,0,2Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M50,30H41a3,3,0,0,1-3-3V19a3,3,0,0,1,3-3h9a3,3,0,0,1,3,3v8A3,3,0,0,1,50,30ZM41,18a1,1,0,0,0-1,1v8a1,1,0,0,0,1,1h9a1,1,0,0,0,1-1V19a1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50,49H41a3,3,0,0,1-3-3V38a3,3,0,0,1,3-3h9a3,3,0,0,1,3,3v8A3,3,0,0,1,50,49ZM41,37a1,1,0,0,0-1,1v8a1,1,0,0,0,1,1h9a1,1,0,0,0,1-1V38a1,1,0,0,0-1-1Z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlowChart);
export default __webpack_public_path__ + "static/media/flow-chart.2d028f90.svg";
export { ForwardRef as ReactComponent };